module.exports = __webpack_public_path__ + "static/media/rohit_magar.ba2fce49.jpg";